export default __webpack_public_path__ + "static/media/Group 376@2x.dd29dd50.png";